import { Dialog, DialogContent } from "@/components/ui/dialog";
import {
  resetCreateFavoriteListAndAddRestaurantToFavoriteList,
  userFavoriteListState,
} from "@/store/userFavoriteListState";

import { useEffect, useState, type FC } from "react";
import CreateFavoriteList from "./components/CreateFavoriteList";
import FavoriteList from "./components/FavoriteList";

type Props = {
  open: boolean;
  onClose: () => void;
  restaurantsId: string[];
};

const AddRestaurantToFavorite: FC<Props> = ({
  open,
  onClose,
  restaurantsId,
}) => {
  const {
    data: favoriteListRestaurants,
    addingRestaurantToFavoriteList,
    addedRestaurantToFavoriteList,
  } = userFavoriteListState();

  const favoriteList = favoriteListRestaurants
    ? Object.values(favoriteListRestaurants).map(
        (favoriteRestaurant) => favoriteRestaurant.favorite,
      )
    : [];

  const [createNewFavorite, setCreateNewFavorite] = useState(false);

  useEffect(() => {
    if (addedRestaurantToFavoriteList) {
      onClose();
    }

    return () => {
      setCreateNewFavorite(false);
      resetCreateFavoriteListAndAddRestaurantToFavoriteList();
    };
  }, [addedRestaurantToFavoriteList]);

  return (
    <Dialog open={open}>
      <DialogContent showCloseButton={false}>
        {(favoriteList && favoriteList.length === 0) || createNewFavorite ? (
          <CreateFavoriteList
            onClose={() => {
              setCreateNewFavorite(false);
              onClose();
            }}
            isLoading={addingRestaurantToFavoriteList}
            restaurantsId={restaurantsId}
          />
        ) : (
          <FavoriteList
            onClose={() => {
              setCreateNewFavorite(false);
              onClose();
            }}
            isLoading={addingRestaurantToFavoriteList}
            restaurantsId={restaurantsId}
            setCreateNewFavorite={setCreateNewFavorite}
            favoriteList={favoriteList}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default AddRestaurantToFavorite;
